@if (showToggle()) {
  @if (variant() === "row") {
    <!-- DS 2.1 row, placed inside the Payment method card on the Subscription page -->
    <div class="tw-flex tw-w-full tw-items-center tw-gap-3 tw-rounded-2xl tw-py-3 tw-pl-2 tw-pr-3">
      <div
        class="tw-flex tw-h-10 tw-w-10 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-xl tw-bg-color-surface-elevated"
      >
        <icon
          [name]="'payment-coins'"
          [size]="5"
          [currentColor]="'color-text-tertiary'"
          aria-hidden="true"
        ></icon>
      </div>
      <div class="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-gap-0.5">
        <p class="tw-m-0 tw-text-sm tw-font-bold tw-leading-5 tw-text-color-text-default">
          {{ "autoCreditRedemptionToggleLabel" | i18n }}
        </p>
        <p class="tw-m-0 tw-text-xs tw-font-medium tw-leading-4 tw-text-color-text-tertiary">
          {{ "autoCreditRedemptionRateDetail" | i18n: (autoRedeemCredits | number) }}
        </p>
      </div>
      <toggle-switch
        class="tw-shrink-0"
        appearance="neumorphic"
        [isEnabled]="isEnabled()"
        [ariaLabel]="'autoCreditRedemptionToggleLabel' | i18n"
        (onClick)="onToggle($event)"
      ></toggle-switch>
    </div>
  } @else {
    <div
      class="tw-flex tw-items-center tw-justify-between tw-w-full tw-rounded-2xl tw-p-6 md:tw-p-4 tw-shadow-card-elevated tw-bg-dt-surface-card"
      [ngClass]="cardClass()"
    >
      <div class="tw-pr-4">
        <p class="tw-m-0 tw-text-sm tw-font-medium tw-text-dt-text-headings">
          {{ "autoCreditRedemptionToggleLabel" | i18n }}
        </p>
        <p class="tw-m-0 tw-mt-1 tw-text-xs tw-text-dt-text-secondary">
          {{ "autoCreditRedemptionToggleDescription" | i18n }}
        </p>
      </div>
      <toggle-switch
        [isEnabled]="isEnabled()"
        colorVariant="success"
        [ariaLabel]="'autoCreditRedemptionToggleLabel' | i18n"
        (onClick)="onToggle($event)"
      ></toggle-switch>
    </div>
  }
}
